import React from 'react'
import { Button, Modal } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ShowImageTable from '../common/ShowImageTable'
const InvitationsMembersModal = ({ open, invitationsMembers, onClose }) => {
  const classes = useStyles()

  console.log('invitationsMembers', invitationsMembers)

  if (invitationsMembers?.length === 0) return null

  return (
    <Modal open={open} onClose={onClose}>
      <div className={classes.modal}>
        <div className={classes.listWrapper}>
          {!!invitationsMembers?.length &&
            invitationsMembers?.map((invitation) => (
              <div key={invitation.id} className={classes.listItem}>
                <ShowImageTable
                  name={`${invitation.firstName} ${invitation.lastName}`}
                  imageUrl={invitation.selfie}
                  ci={invitation.ci}
                />
              </div>
            ))}
        </div>
      </div>
    </Modal>
  )
}

const useStyles = makeStyles((theme) => ({
  modal: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    position: 'fixed',
    minWidth: '300px',
    padding: '20px 60px',
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '30px',
  },
  listWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    overflow: 'auto',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '300px',
    margin: '10px 0',
  },
}))

export default InvitationsMembersModal
